import Strapi from 'strapi-sdk-js';
import Accordion from 'accordion-js';

class DpStrapiAPI {
  constructor(options) {
    this.url = options.url || 'https://strapi-cms-dot-content-371721.ey.r.appspot.com/';
    this.publicationState = options.publicationState || 'live';
    this.strapi = new Strapi({
      url: this.url,
    });
  }

  async getArticles(query, sort) {
    const options = {
      populate: ['topics', 'teaser'],
      sort: 'id:asc',
      publicationState: this.publicationState,
      pagination: {
        pageSize: 1000000,
      },
    };


    switch (sort) {
      case 'title-asc': options.sort = 'title:asc'; break;
      case 'title-desc': options.sort = 'title:desc'; break;
      case 'date-asc': options.sort = 'publishedAt:asc'; break;
      case 'date-desc': options.sort = 'publishedAt:desc'; break;
      default: options.sort = 'title:asc';
    }

    if (query) {
      options.filters = {
        $or: [
          {
            title: {
              $containsi: query,
            },
          },
          {
            subtitle: {
              $containsi: query,
            },
          },
          {
            summary: {
              $containsi: query,
            },
          },
        ],
      };
    }

    const response = await this.strapi.find('articles', options);
    return response;
  }


  async getFAQ(query) {
    const options = {
      populate: ['topics', 'faqCta'],
      sort: ['topics.faqOrder:asc', 'order:asc'],
      publicationState: this.publicationState,
      pagination: {
        pageSize: 1000000,
      },
    };


    if (query) {
      options.filters = {
        $or: [
          {
            answer: {
              $containsi: query,
            },
          },
          {
            question: {
              $containsi: query,
            },
          },
        ],
      };
    }

    const response = await this.strapi.find('faqs', options);
    return response;
  }

  async getSearchResults(query) {
    const url = `${this.url}api/fuzzy-search/search?query=${encodeURIComponent(query)}`;

    const response = await fetch(url);

    if (!response.ok || this.mode === 'error') {
      return false;
    }

    const data = await response.json();
    return data;
  }

  async getTopics() {
    const options = {
      publicationState: this.publicationState,
      pagination: {
        pageSize: 1000000,
      },
    };
    const response = await this.strapi.find('topics', options);
    return response;
  }
}

class DpStaticAPI {
  async getFAQ() {
    const url = '/api/faq.json';
    const response = await fetch(url);

    if (!response.ok || this.mode === 'error') {
      return false;
    }

    const data = await response.json();
    return data;
  }

  async getArticles() {
    const url = '/api/articles.json';
    const response = await fetch(url);

    if (!response.ok || this.mode === 'error') {
      return false;
    }

    const data = await response.json();
    return data;
  }

  async getSearchResults() {
    const url = '/api/search.json';
    const response = await fetch(url);

    if (!response.ok || this.mode === 'error') {
      return false;
    }

    const data = await response.json();
    return data;
  }

  async getTopics() {
    const url = '/api/topics.json';
    const response = await fetch(url);

    if (!response.ok || this.mode === 'error') {
      return false;
    }

    const data = await response.json();
    return data;
  }
}

export default class DpForm {
  constructor(options) {
    this.type = options.type;
    this.mode = options.mode || 'static';
    this.searchField = options.fields.search || false;
    this.searchButton = options.fields.searchButton || false;
    this.showCount = options.showCount || false;
    this.topicsField = options.fields.topics || false;
    this.sortField = options.fields.sort || false;
    this.errorContainer = options.fields.error || false;
    this.resultContainer = options.fields.results || false;
    this.loadMore = options.loadMore || false;
    this.labels = options.labels;
    this.tpl = options.tpl;
    this.urlPrefix = options.urlPrefix || '';
    this.urlPrefixArticle = options.urlPrefixArticle || '';
    this.urlFaq = options.urlFaq || '';
    this.topics = null;
    this.selectedTopicId = -1;
    this.hash = window.location.hash ? window.location.hash.substring(1) : false;
    this.wrapper = options.fields.wrapper || false;

    if (options.query && this.searchField) {
      this.searchField.value = options.query;
    }
    if (this.loadMore && this.loadMore.steps < 1) this.loadMore = false;


    if (this.mode === 'api') {
      this.api = new DpStrapiAPI(options.strapi);
    } else {
      this.api = new DpStaticAPI();
    }
  }

  execSearch = async () => {
    this.selectedTopicId = -1;
    this.res = await this.getResults();
    this.updateTopicsDropdown(this.res.data, -1);
    this.renderResult();
  };

  async init() {
    this.clearError();
    const topics = await this.api.getTopics();
    this.res = await this.getResults();

    if (!topics || !this.res) {
      this.showError();
      return;
    }
    this.clearError();
    this.setTopics(topics);

    this.updateTopicsDropdown(this.res.data, -1);

    this.topicsField.addEventListener('change', (event) => {
      this.selectedTopicId = parseInt(event.target.value, 10);
      this.renderResult();
    });
    if (this.sortField) {
      this.sortField.addEventListener('change', async () => {
        this.res = await this.getResults();
        this.renderResult();
      });
    }

    this.searchButton.addEventListener('click', async () => {
      this.execSearch();
    });
    this.searchField.addEventListener('keypress', async (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.execSearch();
      }
    });
    this.renderResult();
    this.hash = false; // reset hash, we use it only the first time
  }

  async initSearch() {
    this.searchButton.addEventListener('click', async () => {
      this.execSearch();
    });
    this.searchField.addEventListener('keypress', async (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.execSearch();
      }
    });
    if (this.searchField.value) {
      this.res = await this.getResults();
      this.renderResult();
    }
  }

  async getResults() {
    const query = this.searchField.value;
    let sort;
    let res;
    switch (this.type) {
      case 'articles':
        sort = this.sortField.value;
        res = await this.api.getArticles(query, sort);
        break;
      case 'faq':
        res = await this.api.getFAQ(query);
        break;
      case 'search':
        res = await this.api.getSearchResults(query);
        if (res) res.data = res.articles.concat(res.faqs);
        break;
      default:
        return false;
    }
    return res;
  }

  setTopics(topics) {
    const rows = [{ id: -1, title: this.labels.topics_all, count: 0 }];

    topics.data.forEach((item) => {
      if (item.attributes.faqOnly && this.type === 'articles') return;
      const row = {
        id: item.id,
        title: item.attributes.name,
        count: 0,
      };
      rows.push(row);
    });

    rows.sort((a, b) => {
      const fa = a.title.toLowerCase();
      const fb = b.title.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });

    this.topics = rows;
  }

  updateTopicsDropdown(data, selectedValue) {
    if (!this.topicsField) return;
    const counter = {};
    data.forEach((item) => {
      counter[-1] = counter[-1] ? counter[-1] + 1 : 1;

      item.attributes.topics.data.forEach((topicItem) => {
        const { id } = topicItem;
        counter[id] = counter[id] ? counter[id] + 1 : 1;
      });
    });

    const select = this.topicsField;
    select.options.length = 0;

    this.topics.forEach((item) => {
      const count = counter[item.id] ? counter[item.id] : 0;
      const title = this.showCount ? `${item.title} (${count})` : item.title;
      select.options[select.options.length] = new Option(title, item.id);
    });

    if (selectedValue) select.value = selectedValue;
  }

  renderResult() {
    const data = { ...this.res };
    data.labels = this.labels;
    data.loadMore = this.loadMore;
    data.urlPrefix = this.urlPrefix;
    data.urlPrefixArticle = this.urlPrefixArticle;
    data.urlFaq = this.urlFaq;

    if (this.selectedTopicId > 0) {
      data.data = data.data.filter((item) => {
        let addItem = false;
        const { topics } = item.attributes;
        topics.data.forEach((topicsItem) => {
          if (topicsItem.id === parseInt(this.selectedTopicId, 10)) addItem = true;
        });

        return addItem;
      });
    }
    let itemWithHash;
    if (this.hash) {
      itemWithHash = data.data.find(item => item.attributes.slug === this.hash);
      if (itemWithHash) {
        itemWithHash.selected = true;
        const index = data.data.indexOf(itemWithHash);
        data.data.splice(index, 1);
        data.data.unshift(itemWithHash);
      }
    }

    if (this.wrapper) this.wrapper.classList.remove('loading');

    const html = this.tpl.render(data);
    this.resultContainer.innerHTML = html;

    if (this.loadMore) {
      const buttons = this.resultContainer.querySelectorAll(this.loadMore.buttonSelector);
      buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const container = e.target.closest(this.loadMore.itemsContainerSelector);
          let items = [...container.getElementsByClassName('hidden-item')].slice(0, this.loadMore.steps);
          items.forEach((item) => {
            item.classList.remove('hidden-item');
            item.classList.add('show-item');
          });

          items = [...container.getElementsByClassName('hidden-item')];
          const moreButton = button;
          if (!items.length) moreButton.style.display = 'none';
          else moreButton.style.display = 'block';
        });
      });
    }

    if (this.type === 'faq') {
      const accordion = new Accordion(this.resultContainer.querySelector('.accordion--multiple'), {
        duration: 200,
        ariaEnabled: true,
        elementClass: 'accordion__item',
        triggerClass: 'accordion__toggle',
        panelClass: 'accordion__panel',
        activeClass: 'accordion__item--expanded',
        showMultiple: true,
      });
      if (itemWithHash) accordion.open(0);
    }
  }

  showError() {
    if (!this.errorContainer) return;
    this.errorContainer.style.display = 'block';
  }

  clearError() {
    if (!this.errorContainer) return;
    this.errorContainer.style.display = 'none';
  }
}
